<app-text class="is-family-semiBold has-spacing-bottom-xs text-14">
  <ng-content />
</app-text>
